import { join } from '@js/components/resultsRenderHelpers';
import { l, lc } from '@js/utils/toolbox';

export function renderPricehunterTimeline (calendarData, rows, widthPerDay) {
	const { month, dayWidth, days } = calendarData;

	return `
<div id="timeline-data" class="timeline-data">
  <div class="timeline-data-canvas">
    <div class="timeline-data-canvas-prices">
      <div class="timeline-data-canvas-prices-price">
        <span>${month}</span>
      </div>
      ${join(rows, row => `
      <div class="timeline-data-canvas-prices-price">
        <span>${lc(row.price)}</span>
      </div>
      `)}
    </div>

    <div class="timeline-data-inner-container">
      <div class="timeline-data-inner-scroll">

        <div class="timeline-data-canvas-days">
          ${join(days, day => `<div class="timeline-data-canvas-days-day" style="width: ${dayWidth}%"><span>${day}</span></div>`)}
        </div>

        <div class="timeline-data-canvas-cells">
          <div class="timeline-data-canvas-cells-cols">
            ${join(days, (_, index) => `<div class="timeline-data-canvas-cells-cols-col" style="left: ${index * widthPerDay}%"></div>`)}
          </div>

          <div class="timeline-data-canvas-cells-rows">
            ${join(rows, row => `
            <div class="timeline-data-canvas-cells-rows-row">
              <div class="timeline-data-canvas-cells-rows-row-bar" data-index="${row.idx}" style="${barStyle(row.day, row.datediff, widthPerDay)}">
                <span class="timeline-data-canvas-cells-rows-row-bar-city">
                  ${row.localizedtocity} ${row.datediff}${l('pricehunter.timeline.days')}
                </span>
                <span class="timeline-data-canvas-cells-rows-row-bar-iata">
                  ${row.outbound_from} <i class="icon icon-arrow-right"></i> ${row.outbound_to} ${row.datediff}${l('pricehunter.timeline.days')}
                </span>
              </div>
            </div>
            `)}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
}

function barStyle (start, width, widthPerDay = 1) {
	return 'width: ' + (width * widthPerDay) + '%; left: ' + (start * widthPerDay - widthPerDay) + '%';
}
